module.exports = globalThis["Vue"];